import React, { useContext, useMemo } from "react";
import FormulaGenerator from "../../../FormulaGenerator";
import "./index.scss";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const AdentySelectDecayedTooth = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    dentalData,
    setStepFormula,
    setFormulaBeforeTreatment
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    setFormulaBeforeTreatment(data);
    toggleNextBtnState(false);
  }

  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "adentySelectDecayedTooth"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "adentySelectDecayedTooth",
    availableSwitchers: ["top", "bottom", "base"],
    formulaHelperText: formulaHelperText
  }));
};

export default AdentySelectDecayedTooth;